import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";

export class memberTransferMiles {
	private formEl:any = $('#miles-transfer-form');
	private memberBase:any = new memberPortal();

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"]');

		_self.memberBase.initFormTextInputs(inputElArr);
	}

	initRangeInput(): any {
		let _self = this;
		let inputElArr:any   = $.makeArray(_self.formEl.find('input[type="range"]'));

		_self.memberBase.initRangeInput(inputElArr);
	}

	/**
	 * live calculate miles table amount
	 * @return {any} [description]
	 */
	initSummaryTable(): any {
		let _self = this;

		let miles:any         = _self.formEl.find('#miles--to-transfer');
		let milesTable:any    = _self.formEl.find('#miles-transfer-summary-table');
		let rangeInput:any    = _self.formEl.find('#miles--to-transfer');
		let milesTotalCostInput:any = _self.formEl.find('#miles--to-transfer-total-cost');

		let mttt:any              = milesTable.find('#m-t-t-miles-amount');

		let mtttMilesUnitCost:number = parseFloat(milesTable.find('#m-t-t-miles-unitcost')[0].innerHTML);
		let mtttMilesSubtotal:any = milesTable.find('#m-t-t-miles-subtotal');

		let mtttAdminUnitCost:number = parseFloat(milesTable.find('#m-t-t-admin-unitcost')[0].innerHTML);

		let mtttGrandTotal:any    = milesTable.find('#m-t-t-grandtotal');


		rangeInput.on('change', (e:any) => {
			let amt:number = parseFloat(rangeInput.val());

			// set table value for (miles to transfer)
			mttt.html(amt);

			// calculate cost of miles
			let milesSubtotal:number      = amt * mtttMilesUnitCost;
			let milesSubtotalPrint:string = (Math.round(milesSubtotal * 100) / 100).toFixed(2);
			mtttMilesSubtotal.html(milesSubtotalPrint);

			// calculate total cost (incl admin fee)
			let grandTotal:number      = 0;

			if (milesSubtotal > 0) {
				grandTotal = milesSubtotal + mtttAdminUnitCost
			}

			let grandTotalPrint:string = (Math.round(grandTotal * 100) / 100).toFixed(2);
			mtttGrandTotal.html(grandTotalPrint);
			milesTotalCostInput.val(grandTotal);
		});
	}

	initPageInputs(): any {
		let _self = this;

		let milesToTransferVal = parseInt(_self.formEl.find('#miles--to-transfer-initial-value')[0].dataset.initialValue);
		let miles:any               = _self.formEl.find('#miles--to-transfer');
		let rangeInput:any          = _self.formEl.find('#miles--to-transfer-slider');

		// fill miles value at start
		rangeInput.val(milesToTransferVal);
		rangeInput.rangeslider('update', true);

		miles.parent().find('label').addClass('input-filled');
		miles.addClass('input-filled input-focused');
		miles.val(milesToTransferVal);
		miles.trigger('change');

	}

	validateForm(): any {
		let _self = this;

		_self.memberBase.validateForm(_self.formEl, function(validation: any) {
			// all your custom validation here

		});
	}

	initTables(): any {
		let _self = this;

		let transferMilesTable = _self.formEl.find('#miles-transfer-form table');

		_self.memberBase.initTables(transferMilesTable);
	}
}

let scope:Element = document.querySelector('#miles-transfer-form');

if (scope) {
	try {
	let membertransfermiles = new memberTransferMiles();
	// membertransfermiles.initTextInputs();
	// membertransfermiles.initRangeInput();
	// membertransfermiles.initSummaryTable();
	// membertransfermiles.initPageInputs();
	// membertransfermiles.validateForm();
	// membertransfermiles.initTables();    
	
	
	} catch(e) {console.error(e);}
}
